import BaseMesh from './BaseMesh.js';
import Collection from './Collection.js';

// props: type, name, visible
// No need to override function: updateProps()
class Index extends BaseMesh {
  static zoomToCameraPositionZ(zoom) {
    return 5000 / zoom;
  }

  static cameraPositionZToZoom(z) {
    return 5000 / z;
  }

  constructor(data, camera) {
    super(data);
    this._camera = camera;
    this._center = null;
    this._zoom = null;
    this._LineElements = [];
    // 渲染 collections
    data.children.forEach(collectionData => {
      const collection = new Collection(collectionData);
      this.add(collection);
      // 添加线条元素
      const lineElm = collection.getLineElement();
      // console.log()
      if (lineElm) {
        this.add(lineElm);
        this._LineElements.push(lineElm);
      }
    });
    const { center, zoom } = this.props;
    this._camera.position.z = Index.zoomToCameraPositionZ(zoom);
    this._camera.position.x = center[0];
    this._camera.position.y = center[1];
  }
  setLineElements(LineElments) {
    this._LineElements = LineElments;
  }
  getLineElements() {
    return this._LineElements;
  }
  updateProps(key, value) {
    super.updateProps(key, value);
    switch (key) {
      case 'minZoom':
        break;
      case 'maxZoom':
        break;
      case 'zoom':
        this._camera.position.z = Index.zoomToCameraPositionZ(value);
        break;
      case 'center':
        this._camera.position.x = value[0];
        this._camera.position.y = value[1];
        break;
    }
  }
}

export default Index;
